import { CoveragePlanCard, CoveragePlanType } from '@cms-max/medicare-api-sdk'
import { useMemo } from 'react'
import { useCombinedPartAPartB } from './useCombinedPartAPartB'

type Args = {
  plans?: Array<CoveragePlanCard>
}
export default function useCombineAndFilterPlans ({ plans = [] }: Args) {
  const omCombined = useCombinedPartAPartB({ plans })

  const filteredPlans = useMemo(() => {
    if (!omCombined) return plans

    const filtered =
      plans.filter(
        (plan) =>
          ![CoveragePlanType.OmPartA, CoveragePlanType.OmPartB].includes(
            plan.type
          )
      ) || []

    return [...filtered]
  }, [plans, omCombined])

  return {
    omCombined,
    filteredPlans
  }
}
